

















































































/* eslint-disable */
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import EditIcon from 'mdi-vue/Pencil';
import Checkbox from '@/components/Checkbox.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import SimplePagination from '@/components/SimplePagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';

import api from '@/libs/api';
import format from '@/libs/numberFormat';
import { AxiosError } from 'axios';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import { InvoiceProduct } from '@/libs/api.interfaces';

interface ReportParams {
  profile: LabelValue | null;
  name: string;
}

@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    Pagination,
    Checkbox,
    ActionPopup,
    SimplePagination,
    EditIcon,
  },
  methods: {
    format,
  },
})
export default class InvoiceReportTable extends Vue {
  loading = true;
  products: InvoiceProduct[] = [];

  // merchantLoginData: any = this.$store.state.user.user.merchant;
  params: ReportParams = {} as ReportParams;

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  format!: typeof format;
  // openDetail(id: number) {
  //   window.open(`/easyinvoice/etransaction/invoicedetail/${id}`, '_blank');
  // }
  openDetail(id: string) {
    this.$router.push(`/easyinvoice/configuration/product/${id}`);
  }

  //  mounted() {
  //    this.getTransaction();
  //   }

  @Watch('page')
  onPageChange() {
    this.$router.push({
      query: { ...this.$route.query, page: this.page.toString() },
    });
  }
  // extractStatus(str: String) {
  //   let status = new RegExp(/(<span)[ a-z0-9A-Z\"\\=\-]*(\>)([A-Za-z 0-9]*)(<\/span>)/).exec(str);
  //   return status !== null ? status[3] : "-";
  // }
  // extractTransactionNumber(str: String) {
  //   let transactionNumber = new RegExp(/(<a)[ a-z0-9A-Z\"\\=\-\'.\/\:_]*(\>)([A-Za-z 0-9#]*)(<\/a>)/).exec(str);
  //   return transactionNumber !== null ? transactionNumber[3] : "-";
  // }

  async getProducts(parameters: ReportParams, page = 1) {
    this.params = parameters;
    try {
      this.loading = true;

      const { data } = await api.post('/easyinvoice/products', {
        /* eslint-disable-next-line @typescript-eslint/camelcase */
        page,
        start: 0,
        length: 10,
        user_group: 1,
        product_name: this.params.name === '' ? undefined : this.params.name,
        profile: this.params.profile === null ? undefined : Number(this.params.profile.value)
      });
      if (data.data) {
        this.page = page;
        this.products = data.data.data;
        this.totalPage = Math.ceil(data.total / data.per_page);
        this.from = data.from;
        this.to = data.to;
        this.totalItem = data.total;
      }
      // showToast(ToastType.SUCCESS, 'Data Transaction All Loaded', 'finished');
      // if(data.total === 0){
      //   showToast(ToastType.FAILED, 'Oops… Sorry, data not allowed','Change your filter');
      // }
      this.loading = false;
      return null;
    } catch (err) {
      // console.log(err);
      // showToast(ToastType.FAILED, 'Oops… Sorry', err.response.data.error.errors[0].message);
      this.loading = false;
      // return err as AxiosError;
    }
  }
}
